import { render, staticRenderFns } from "./httzck.vue?vue&type=template&id=48110c51&scoped=true"
import script from "./httzck.vue?vue&type=script&lang=js"
export * from "./httzck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48110c51",
  null
  
)

export default component.exports